import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import {withStyles, Link} from '@material-ui/core';

import {InferPropTypes} from 'commons/types/Types';
import {MuiLinkStyles} from 'assets/tss/layouts/components';

EfeLink.propTypes = {
    content: PropTypes.string.isRequired,
    bold: PropTypes.bool.isRequired,
};

/* eslint-disable react/jsx-handler-names */

function EfeLink(props: InferPropTypes<typeof EfeLink.propTypes & any, typeof MuiLinkStyles>) {
    const {content, bold, classes, ...other} = props;

    return (
        <Link className={clsx(bold ? classes.bold : '')} {...other}>
            {content}
        </Link>
    );
}

export default withStyles(MuiLinkStyles)(EfeLink);
